/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface OAuthAppSpec { 
    /**
     * Organization Id.
     */
    org_id: string;
    service_type: ServiceTypeEnum;
    /**
     * Cloud Provider Region ID
     */
    region: string;
    /**
     * Choice of client id to be used while creating crdentials. <br> Typical format [service type]-[org id]-[region id]-[WEB/NATIVE].
     */
    client_id?: string;
    /**
     * FQDN for the VCDR instance corresponding to IP.
     */
    irr_gateway_fqdn?: string;
    /**
     * IRR Gateway IP address.
     */
    irr_gateway_ip: string;
    /**
     * Time to live for access token in seconds.
     */
    access_token_ttl?: number;
    /**
     * List of org Ids which are to be allowed for this app. <br> As default ones, org Id from payload and service org Id will be added.
     */
    allowed_orgs?: Array<string>;
    /**
     * Time to live for refresh token in seconds.
     */
    refresh_token_ttl?: number;
}
export namespace OAuthAppSpec {
}


